'use client';

import React, { useCallback, useMemo } from 'react';
import { useTranslation, useUi } from '@weareconceptstudio/core';
import { useCart } from '@weareconceptstudio/cart';
import { AddressItem, useAccountContext, useAddressContext } from '@weareconceptstudio/account';
import DeliveryTemplate from '@/modules/Checkout/DeliveryTemplate';
import { buildFulfillmentCheckoutDisplay } from '@/utils/fulfillmentDisplay';

const FulfillmentCheckoutInfo = () => {
	const { openPopup } = useUi();
	const { translate, selectedLang } = useTranslation();
	const { checkoutData } = useCart();
	const { fulfillment, useUser } = useAccountContext();
	const { selectedAddresses, hasAddressType } = useAddressContext();
	const { user } = useUser();

	const branches = fulfillment?.branches || [];

	const selectedBranch = useMemo(
		() =>
			branches.find((b) => Number(b.id) === Number(checkoutData?.fulfillmentBranchId)) ||
			branches[0] ||
			null,
		[branches, checkoutData?.fulfillmentBranchId]
	);

	const selectedAddress = useMemo(() => {
		if (hasAddressType) return selectedAddresses?.shipping || null;
		return selectedAddresses || null;
	}, [hasAddressType, selectedAddresses]);

	const { titleKey, footerKey, displayLines, isTakeaway, hasContent } = useMemo(
		() =>
			buildFulfillmentCheckoutDisplay({
				checkoutData,
				selectedAddress,
				selectedBranch,
				phone: checkoutData?.fulfillmentType === 'takeaway'
				? (checkoutData?.phone || user?.takeaway_phone || user?.phone)
				: (selectedAddress?.phone || user?.phone),
				translate,
				locale: selectedLang,
			}),
		[checkoutData, selectedAddress, selectedBranch, checkoutData?.phone, user?.takeaway_phone, user?.phone, translate, selectedLang]
	);

	const openChangePopup = useCallback(() => {
		openPopup(<DeliveryTemplate initialTab={isTakeaway ? 'takeaway' : 'delivery'} />, {
			className: 'delivery-template-popup',
		});
	}, [isTakeaway, openPopup]);

	if (!hasContent) return null;

	return (
		<AddressItem
			checkout_review
			disableGutter
			type='shipping'
			title={titleKey}
			select_address={false}
			data={{
				id: 'fulfillment-checkout',
				displayLines,
				is_default: false,
			}}
			footerLabel={footerKey}
			onClick={openChangePopup}
		/>
	);
};

export default FulfillmentCheckoutInfo;
